import { render, staticRenderFns } from "./MemberData.vue?vue&type=template&id=64944eea&scoped=true&"
import script from "./MemberData.vue?vue&type=script&lang=js&"
export * from "./MemberData.vue?vue&type=script&lang=js&"
import style0 from "./MemberData.vue?vue&type=style&index=0&id=64944eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64944eea",
  null
  
)

export default component.exports